import { Color } from '@diritto/common/style/color';
import { Typography } from '@diritto/common/style/typography';
import styled from '@emotion/styled';
import { NoticeBadge } from 'app-components/contents/detail/NoticeBadge';
import { useEpisodeState } from 'state-hooks/episode/useEpisodeState';
import { Link } from 'ui-components/common/Link';
import { EpisodePublicRelayDto } from '@diritto/common/relay/dtos/episode-relay.dtos';
import { AdultBadgeIcon } from 'icons/badge/AdultBadgeIcon';

export const ContentDetailNoticeItem = ({
  episode,
  isAdultContent,
}: {
  episode: EpisodePublicRelayDto;
  isAdultContent: boolean;
}) => {
  const { isAdult } = useEpisodeState(episode, isAdultContent);
  return (
    <Link href={`/contents/${episode.contentId}/episodes/${episode.id}`}>
      <StyledContainer>
        <NoticeBadge color={Color.Primary500} />
        {isAdult && (
          <StyledIconWrap>
            <AdultBadgeIcon />
          </StyledIconWrap>
        )}
        <p>{episode.title}</p>
      </StyledContainer>
    </Link>
  );
};

const StyledContainer = styled.div`
  display: flex;
  align-items: center;
  height: 44px;
  width: 100%;
  border-bottom: 1px solid ${Color.Gray200};

  & > p {
    ${Typography.XXSmall};
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    line-clamp: 1;
    word-break: break-all;
    word-wrap: anywhere;
    margin-left: 8px;
  }
`;

const StyledIconWrap = styled.div`
  display: flex;
  align-items: center;
  width: 18px;
  margin-left: 8px;
`;
